import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";
import {
  OffsiteCampaignContext,
  OffsiteCampaignContextType,
} from "context/OffsiteCampaignProvider";
import RetailDrawer from "components/Drawer/RetailDrawer";
import RetailTitle from "components/Typography/RetailTitle";
import RetailText from "components/Typography/RetailText";
import RetailSelect from "components/Select/RetailSelect";
import cm from "./style.module.scss";
interface OffsiteAudienceDrawerProps {
  visible: boolean;
  onClose: () => void;
  selectedAudience: string;
  audienceOptions: Array<{ value: string; label: string }>;
  isLoadingAudiences: boolean;
  handleSelectedAudienceChange: (value: string) => void;
}

const OffsiteAudienceDrawer = ({
  visible,
  onClose,
  selectedAudience,
  audienceOptions,
  isLoadingAudiences,
  handleSelectedAudienceChange,
}: OffsiteAudienceDrawerProps) => {
  const { t } = useTranslation();

  const { formFields, setFormFields } = useContext(
    OffsiteCampaignContext
  ) as OffsiteCampaignContextType;

  const onOk = () => {
    setFormFields({
      ...formFields,
      audience: selectedAudience,
    });
    onClose();
  };

  const handleClear = () => handleSelectedAudienceChange("");

  return (
    <RetailDrawer
      title={t("components.offsiteCampaignForm.firstStep.selectAudience")}
      visible={visible}
      onClose={onClose}
      onOk={onOk}
      width={500}
      placement="right"
      maskClosable={true}
      keyboard={true}
    >
      <RetailTitle level={5} className={cm.drawerTitle}>
        {t("components.offsiteCampaignForm.firstStep.audienceSelection")}
      </RetailTitle>
      <RetailText className={cm.drawerText} size="xxxs">
        {t("components.offsiteCampaignForm.firstStep.audienceSelectionText")}
      </RetailText>

      <RetailSelect
        placeholder={t(
          "components.offsiteCampaignForm.firstStep.selectAudiencePlaceholder"
        )}
        onChange={handleSelectedAudienceChange}
        value={selectedAudience ? selectedAudience : undefined}
        style={{ width: "100%" }}
        options={audienceOptions}
        className={cm.audienceSelect}
        loading={isLoadingAudiences}
        onClear={handleClear}
        clearIcon={<CloseOutlined className={cm.clearIcon} />}
        allowClear
      />

      <RetailText
        className={cm.drawerText}
        size="xxxs"
        style={{ marginTop: "12px" }}
      >
        {t("components.offsiteCampaignForm.firstStep.audienceNote")}
      </RetailText>
    </RetailDrawer>
  );
};

export default OffsiteAudienceDrawer;
